export const WORLD = {
    width: 2200,
    height: 1700,
    spawn: { x: 1100, y: 850, minRadius: 165, maxRadius: 245 },
    fountain: { x: 1100, y: 850, visualRadius: 88, collisionRadius: 112 },
    statue: { x: 1100, y: 315, collisionRadius: 72 },
    drawingTable: { x: 1390, y: 760, collisionRadius: 105, interactionRadius: 175 },
    macaoTable: { x: 810, y: 760, collisionRadius: 105, interactionRadius: 175 },
    playerSpeed: 190,
    chatRadius: 3_000,
    chatMaxLength: 180,
    chatBubbleMs: 7_000,
    chatFeedMs: 45_000,
    serverTickRate: 20,
    maxPlayers: 80,
};
export const TREE_OBSTACLES = [
    { x: 150, y: 170, radius: 52 }, { x: 690, y: 150, radius: 50 }, { x: 950, y: 180, radius: 52 },
    { x: 1250, y: 160, radius: 52 }, { x: 1520, y: 170, radius: 50 }, { x: 2050, y: 175, radius: 52 },
    { x: 150, y: 680, radius: 52 }, { x: 150, y: 1050, radius: 52 }, { x: 2050, y: 700, radius: 54 },
    { x: 2050, y: 1050, radius: 52 }, { x: 160, y: 1600, radius: 50 }, { x: 700, y: 1610, radius: 50 },
    { x: 980, y: 1580, radius: 52 }, { x: 1250, y: 1600, radius: 52 }, { x: 1510, y: 1580, radius: 54 },
    { x: 2050, y: 1600, radius: 52 }, { x: 700, y: 545, radius: 50 }, { x: 1500, y: 545, radius: 50 },
    { x: 700, y: 1160, radius: 50 }, { x: 1500, y: 1160, radius: 50 },
];
export const BENCHES = [
    { id: "stories", label: "Banca poveștilor", x: 370, y: 465, width: 330, wood: 0xc77c5d, edge: 0x7f4c45, accent: 0xf6c4b4 },
    { id: "sun", label: "Banca cu soare", x: 1830, y: 455, width: 340, wood: 0xe0ad69, edge: 0x8f6547, accent: 0xffe2a8 },
    { id: "laughs", label: "Banca de râs", x: 380, y: 1540, width: 350, wood: 0xa98bc7, edge: 0x67537e, accent: 0xe4d0f3 },
    { id: "friends", label: "Banca prietenilor", x: 1820, y: 1535, width: 340, wood: 0x79aa85, edge: 0x486b52, accent: 0xc4e2c7 },
];
export function findBenchAt(x, y) {
    return BENCHES.find((bench) => Math.abs(x - bench.x) <= bench.width / 2 - 24 && y >= bench.y - 58 && y <= bench.y + 28);
}
export function loungePosition(bench, x) {
    return {
        x: Math.max(bench.x - bench.width / 2 + 86, Math.min(bench.x + bench.width / 2 - 86, x)),
        y: bench.y + 10,
    };
}
export function randomLoungeRotation(random = Math.random) {
    const sample = random();
    const direction = sample < 0.5 ? -1 : 1;
    const variation = ((sample % 0.5) / 0.5 - 0.5) * 0.24;
    return direction * (Math.PI / 2 + variation);
}
const STATIC_CIRCLE_OBSTACLES = [
    { x: WORLD.fountain.x, y: WORLD.fountain.y, radius: WORLD.fountain.collisionRadius },
    { x: WORLD.statue.x, y: WORLD.statue.y, radius: WORLD.statue.collisionRadius },
    { x: WORLD.drawingTable.x, y: WORLD.drawingTable.y, radius: WORLD.drawingTable.collisionRadius },
    { x: WORLD.macaoTable.x, y: WORLD.macaoTable.y, radius: WORLD.macaoTable.collisionRadius },
    ...TREE_OBSTACLES,
];
export function createSpawnPoint(random = Math.random) {
    const angle = random() * Math.PI * 2;
    const minSquared = WORLD.spawn.minRadius ** 2;
    const maxSquared = WORLD.spawn.maxRadius ** 2;
    const radius = Math.sqrt(minSquared + random() * (maxSquared - minSquared));
    return constrainWorldPosition(WORLD.spawn.x + Math.cos(angle) * radius, WORLD.spawn.y + Math.sin(angle) * radius);
}
export function constrainWorldPosition(x, y) {
    let nextX = Math.max(70, Math.min(WORLD.width - 70, x));
    let nextY = Math.max(100, Math.min(WORLD.height - 70, y));
    for (const obstacle of STATIC_CIRCLE_OBSTACLES) {
        const dx = nextX - obstacle.x;
        const dy = nextY - obstacle.y;
        const distance = Math.hypot(dx, dy);
        if (distance >= obstacle.radius)
            continue;
        const scale = obstacle.radius / Math.max(distance, 0.0001);
        nextX = obstacle.x + (distance === 0 ? obstacle.radius : dx * scale);
        nextY = obstacle.y + (distance === 0 ? 0 : dy * scale);
    }
    return { x: nextX, y: nextY };
}
export const SESSION_REPLACED_CLOSE_CODE = 4101;
export const EMOTES = ["dance", "stunt", "jump"];
export const EMOTE_DURATION_MS = 4_000;
export const OUTFITS = [
    { id: "female_sport", avatarType: "female", label: "Sport roz" },
    { id: "female_noir", avatarType: "female", label: "Noir cute" },
    { id: "female_blush", avatarType: "female", label: "Blush denim" },
    { id: "male_urban", avatarType: "male", label: "Urban negru" },
    { id: "male_sand", avatarType: "male", label: "Sand denim" },
    { id: "male_varsity", avatarType: "male", label: "Varsity" },
];
export function defaultOutfitFor(type) {
    return type === "female" ? "female_sport" : "male_urban";
}
export function outfitsFor(type) {
    return OUTFITS.filter((outfit) => outfit.avatarType === type);
}
export function validateOutfit(value, type) {
    const outfit = OUTFITS.find((candidate) => candidate.id === value);
    return outfit && (!type || outfit.avatarType === type) ? outfit.id : null;
}
export function avatarPartsFor(type, outfitInput) {
    const outfit = validateOutfit(outfitInput, type) ?? defaultOutfitFor(type);
    return {
        head: `${type}_head_default`,
        top: `${outfit}_top`,
        pants: `${outfit}_pants`,
        shoes: `${outfit}_shoes`,
    };
}
export function outfitFromParts(type, parts) {
    const parsed = typeof parts?.top === "string" ? parts.top.replace(/_top$/, "") : "";
    return validateOutfit(parsed, type) ?? defaultOutfitFor(type);
}
export function sanitizePlainText(value, maxLength) {
    if (typeof value !== "string" || value.length > maxLength * 4)
        return null;
    const cleaned = value.replace(/[\u0000-\u001F\u007F]/g, " ").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
    if (!cleaned || cleaned.length > maxLength)
        return null;
    return cleaned;
}
export function validateDisplayName(value) {
    const name = sanitizePlainText(value, 20);
    return name && name.length >= 3 ? name : null;
}
export function validateMovement(value) {
    if (!value || typeof value !== "object")
        return null;
    const input = value;
    if (input.type !== "movement_input" || !Number.isFinite(input.x) || !Number.isFinite(input.y) || !Number.isSafeInteger(input.sequence))
        return null;
    const x = Number(input.x);
    const y = Number(input.y);
    if (x < -1 || x > 1 || y < -1 || y > 1 || Number(input.sequence) < 0)
        return null;
    const length = Math.hypot(x, y);
    if (length > 1.05)
        return null;
    return { type: "movement_input", x, y, sequence: Number(input.sequence) };
}
export function validatePresence(value) {
    if (!value || typeof value !== "object")
        return null;
    const input = value;
    return input.type === "presence" && typeof input.away === "boolean" ? { type: "presence", away: input.away } : null;
}
export function validateTyping(value) {
    if (!value || typeof value !== "object")
        return null;
    const input = value;
    return input.type === "typing" && typeof input.active === "boolean" ? { type: "typing", active: input.active } : null;
}
export function validateDisplayNameUpdate(value) {
    if (!value || typeof value !== "object")
        return null;
    const input = value;
    const displayName = input.type === "display_name" ? validateDisplayName(input.displayName) : null;
    return displayName ? { type: "display_name", displayName } : null;
}
export function validateEmote(value) {
    if (!value || typeof value !== "object")
        return null;
    const input = value;
    return input.type === "emote" && EMOTES.includes(input.emote)
        ? { type: "emote", emote: input.emote }
        : null;
}
export function validateAppearance(value, type) {
    if (!value || typeof value !== "object")
        return null;
    const input = value;
    const outfit = input.type === "appearance" ? validateOutfit(input.outfit, type) : null;
    return outfit ? { type: "appearance", outfit } : null;
}
export function directionFromVector(x, y, fallback = "down") {
    if (Math.hypot(x, y) < 0.05)
        return fallback;
    if (Math.abs(x) > Math.abs(y))
        return x < 0 ? "left" : "right";
    return y < 0 ? "up" : "down";
}
export function relativeAge(createdAt, now = Date.now()) {
    const elapsed = Math.max(0, now - new Date(createdAt).getTime());
    const minutes = Math.floor(elapsed / 60_000);
    if (minutes < 1)
        return "acum câteva clipe";
    if (minutes < 60)
        return `acum ${minutes} ${minutes === 1 ? "minut" : "minute"}`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24)
        return `acum ${hours} ${hours === 1 ? "oră" : "ore"}`;
    const days = Math.floor(hours / 24);
    if (days < 30)
        return `acum ${days} ${days === 1 ? "zi" : "zile"}`;
    const months = Math.floor(days / 30);
    if (months < 12)
        return `acum ${months} ${months === 1 ? "lună" : "luni"}`;
    const years = Math.floor(months / 12);
    return `acum ${years} ${years === 1 ? "an" : "ani"}`;
}
export function pruneExpired(items, now = Date.now(), max = 30) {
    return items.filter((item) => item.expiresAt > now).slice(-max);
}
export * from "./drawing-game.js";
export * from "./macao-game.js";
